<template>
  <div>
    <el-row :gutter='16' class='nav-row'>
      <el-col :lg='8' :md='12' :sm='24' v-for='(v ,k) in navMenus' :key='k'>
        <el-card shadow='hover' class='nav-card'>
          <div class='nav-card__title' :title='v.display_name'>
            {{ v.display_name }}<template v-if='v.children && v.children.length'>（{{ v.children.length }}）</template>
          </div>
          <div class='nav-card__links'>
            <template v-if='(v.children && v.children.length)'>
              <el-link v-for='(item, indx) in v.children' :key='k + "-" + indx' class='nav-link'
                       type='primary' :underline='false' @click='goToPage(item.url,item)'
                       :disabled="v['permission_name'] &&!(userPermissions.indexOf(item['permission_name']) > -1)"
              >
                <svg-icon :icon-class="item['icon']"></svg-icon>
                <span :title="item['url']">{{ item['display_name'] }}</span>
              </el-link>
            </template>
            <template v-else>
              <el-link class='nav-link' type='primary' :underline='false' @click='goToPage(v.url,v)'
                       :disabled="v['permission_name'] &&!(userPermissions.indexOf(v['permission_name']) > -1)">
                <svg-icon :icon-class='v.icon'></svg-icon>
                <span :title='v.url'>{{ v.display_name }}</span>
              </el-link>
            </template>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import menuApi from '@/api/menu_setting'

export default {
  name: 'UserComponentsAllMenusOld',
  computed: {
    ...mapGetters(['userPermissions'])
  },
  data() {
    return {
      navMenus: []
    }
  },
  methods: {
    goToPage(routeName, menu) {
      if (menu.type === 'button') {
        this.$utils.jumpToButtonUrl(menu.url)
        return
      }
      this.$utils.jumpPage(this, routeName, menu)
    },
    async fetchMenuTree() {
      try {
        const res = await menuApi.getMenuTree()
        const list = Array.isArray(res) ? res : Object.values(res || {})
        const activeList = this.filterActiveMenus(list)
        const sortedList = activeList.sort((a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0))
        this.navMenus = sortedList
      } catch (e) {
        console.error('获取菜单树失败', e)
      }
    },
    filterActiveMenus(menus) {
      return menus
        .filter(item => String(item.status) === '1')
        .map(item => {
          const filteredChildren = item.children ? this.filterActiveMenus(item.children) : []
          if (item.children && item.children.length > 0 && filteredChildren.length === 0) {
            return null
          }
          return { ...item, children: filteredChildren }
        })
        .filter(Boolean)
    }
  },
  mounted() {
    this.fetchMenuTree()
  }
}
</script>

<style lang='scss' scoped>
.nav-row {
  flex-wrap: wrap !important;
  display: flex;
}

.nav-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border-color: $--border-Lighter-color;
  transition: border-color .2s ease, box-shadow .2s ease;

  &:hover {
    border-color: #ffd6e5;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .05);
  }

  ::v-deep .el-card__body {
    padding: 12px 14px;
  }

  &__title {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px dashed $--border-Lighter-color;
    color: $--color-text-regular;
    font-size: 13px;
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__links {
    display: flex;
    flex-wrap: wrap;
  }

  .nav-link {
    display: inline-flex;
    justify-content: flex-start;
    max-width: 100%;
    margin: 0 8px 6px 0;
    padding: 3px 6px;
    border: 1px solid transparent;
    border-radius: 6px;
    color: $--color-text-primary;
    font-size: 13px;
    font-weight: 400;
    transition: background-color .2s ease, border-color .2s ease, color .2s ease;

    ::v-deep .el-link--inner {
      display: flex;
      align-items: center;
      min-width: 0;
    }

    ::v-deep .svg-icon {
      flex-shrink: 0;
      margin: 0 5px 0 0;
      font-size: 15px;
      color: #ff3176;
    }

    ::v-deep .el-link--inner > span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &:hover {
      background: #fff5f9;
      border-color: #ff3176;
      color: #ff3176;
    }

    &.disabled,
    &.is-disabled {
      color: $--color-text-Placeholder;
      cursor: not-allowed;

      ::v-deep .svg-icon {
        color: $--color-text-Placeholder !important;
      }

      &:hover {
        background: transparent;
        border-color: transparent;
        color: $--color-text-Placeholder;
      }
    }
  }
}
</style>
